export default class ModuleFactory {
  constructor() {
    const modules = document.querySelectorAll('[data-module]');

    modules.forEach((module) => {
      new Module(module);
    });
  }
}

class Module {
  constructor(root) {
    root.querySelectorAll('[data-action="toggle"]').forEach((elToggle) => {
      elToggle.addEventListener('click', () => this.toggle(root));
    });

    root.querySelectorAll('[data-action="close"]').forEach((elClose) => {
      elClose.addEventListener('click', () => this.close(root));
    });
  }

  toggle(root) {
    root.classList.toggle('is-open');
  }

  close(root) {
    root.classList.remove('is-open');
  }
}
